export const getFileSizeInKb = (sizeInBytes: number): string => `${Math.floor(sizeInBytes / 1024)}kB`;
